import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

export const STUDIO_BROKER_INSIGHTS =
  `${BASE_URL}/rest/v1.0/reporting/studio/{username}/broker-insights-by-user`;
